import { RouteConfig } from 'vue-router';

const TongueList = () => import(/* webpackChunkName: "Tongue" */  './views/tongue-list/tongue-list.vue');
const DataExport = () => import(/* webpackChunkName: "Tongue" */  './views/data-export/data-export.vue');
const ExportResults = () => import(/* webpackChunkName: "Tongue" */  './views/export-results/export-results.vue');
const TonguePreview = () => import(/* webpackChunkName: "Tongue" */  './views/tongue-preview/tongue-preview.vue');
const BiaozhuDetail = () => import(/* webpackChunkName: "Tongue" */  './views/biaozhu-detail/biaozhu-detail.vue');
const BiduiList = () => import(/* webpackChunkName: "Tongue" */  './views/bidui-list/bidui-list.vue');
const BiduiResult = () => import(/* webpackChunkName: "Tongue" */  './views/bidui-result/bidui-result.vue');
const BiduiPreview = () => import(/* webpackChunkName: "Tongue" */  './views/bidui-preview/bidui-preview.vue');





const routers: RouteConfig[] = [
    {
        path: 'tongue-list',
        component: TongueList,
    },
    {
        path: 'data-export',
        component: DataExport
    },
    {
        path: 'export-results',
        component: ExportResults
    },
    {
        path: 'tongue-preview',
        component: TonguePreview
    },
    {
        path: 'biaozhu-detail',
        component: BiaozhuDetail
    },
    {
        path: 'bidui-list',
        component: BiduiList
    },
    {
        path: 'bidui-result',
        component: BiduiResult
    },
    {
        path: 'bidui-preview',
        component: BiduiPreview
    },
    {
        path: '',
        redirect: 'tongue-list'
    },
];

export default routers;

